import { Accordion, Grid } from '@mantine/core';
import { BusinessTypes } from '../../../enums/business-type';
import XInfoTabTitle from '../../x-components/x-info-tab-title.component';
import {
  RetrievedIncorporator,
  RetrievedSignatory,
} from '../../../type/onboard-merchant-request.types';
import MerchantInfoSignatory from './merchant-info-signatory.component';
import MerchantInfoIncorporator from './merchant-info-incorporator.component';

interface MerchantInfoIncorporatorsSignatoriesProps {
  signatoriesData?: RetrievedSignatory[];
  incorporatorsData?: RetrievedIncorporator[];
  businessTypeId: BusinessTypes;
}

function MerchantInfoIncorporatorsSignatories(
  props: MerchantInfoIncorporatorsSignatoriesProps
) {
  const { signatoriesData, incorporatorsData, businessTypeId } = props;

  const signatories = signatoriesData?.map((signatory, index) => {
    return (
      <Accordion.Item
        key={index}
        label={'Signatory ' + (index + 1)}
        data-cy={'signatory' + index}
        opened
      >
        <MerchantInfoSignatory signatory={signatory} />
      </Accordion.Item>
    );
  });

  const incorporators = incorporatorsData?.map((incorporator, index) => {
    return (
      <Accordion.Item
        key={index}
        data-cy={'incorporator' + index}
        label={
          businessTypeId === BusinessTypes.SOLE_PROPRIETOR
            ? 'Proprietor '
            : 'Incorporator ' + (index + 1)
        }
        opened
      >
        <MerchantInfoIncorporator incorporator={incorporator} />
      </Accordion.Item>
    );
  });

  return (
    <>
      <Grid>
        {businessTypeId !== BusinessTypes.STARTER &&
          incorporatorsData &&
          incorporatorsData.length > 0 && (
            <>
              <Grid.Col>
                <XInfoTabTitle
                  label={
                    businessTypeId === BusinessTypes.SOLE_PROPRIETOR
                      ? 'Proprietor'
                      : 'Incorporator'
                  }
                  dataCy='incorporatorsTitle'
                />
              </Grid.Col>
              <Grid.Col>
                <Accordion
                  multiple
                  initialItem={0}
                  data-cy='incorporatorsAccordion'
                >
                  {incorporators}
                </Accordion>
              </Grid.Col>
            </>
          )}
        {signatoriesData && signatoriesData.length > 0 && (
          <>
            <Grid.Col>
              <XInfoTabTitle label='Signatory' />
            </Grid.Col>
            <Grid.Col>
              <Accordion
                multiple
                initialItem={0}
                data-cy='signatoriesAccordion'
              >
                {signatories}
              </Accordion>
            </Grid.Col>
          </>
        )}
      </Grid>
    </>
  );
}

export default MerchantInfoIncorporatorsSignatories;
